import { FETCH_PROFILE } from './constants'

import { failure, success, status } from '@utils/redux'

const initialState = {
  data: {},
  status: status.PRISTINE,
  error: {}
}

const user = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PROFILE:
      return {
        ...state,
        status: status.FETCHING
      }
    case failure(FETCH_PROFILE):
      return {
        ...state,
        status: status.ERROR,
        error: action.error
      }
    case success(FETCH_PROFILE):
      return {
        ...state,
        status: status.LOADED,
        error: false,
        data: action.payload.data
      }
    default:
      return state
  }
}

export default user
